var React = require('react');

function ArrowRightIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.0607 12.1066C23.6464 11.5208 23.6464 10.571 23.0607 9.98524L13.5147 0.439296C12.9289 -0.146491 11.9792 -0.146491 11.3934 0.439296C10.8076 1.02508 10.8076 1.97483 11.3934 2.56062L19.8787 11.0459L11.3934 19.5312C10.8076 20.117 10.8076 21.0667 11.3934 21.6525C11.9792 22.2383 12.9289 22.2383 13.5147 21.6525L23.0607 12.1066ZM0 11.0459L1.31134e-07 12.5459L22 12.5459L22 11.0459L22 9.5459L-1.31134e-07 9.5459L0 11.0459Z","fill":"#00FFEE"}));
}

ArrowRightIcon.defaultProps = {"width":"24","height":"23","viewBox":"0 0 24 23","fill":"none"};

module.exports = ArrowRightIcon;

ArrowRightIcon.default = ArrowRightIcon;
